import { SelectOption } from '@components/select';
import {
  ExtendedFieldMappingEditorValue,
  transformSimpleValueInput,
} from '@components/text-editors/addons/field-mapping';
import { createPlaceholderHtml, createPlaceholderNode } from '@components/text-editors/helpers';

export const tag = 'select-placeholder';

const attributes = ['value', 'label'];

export const getPlaceholderHtml = createPlaceholderHtml({ tag, attributes });

export const SelectPlaceholder = createPlaceholderNode({
  attributes,
  renderText: getPlaceholderHtml,
  tag,
});

export const transformInput = (input: ExtendedFieldMappingEditorValue[], options: SelectOption[]) =>
  transformSimpleValueInput(input, (value) =>
    getPlaceholderHtml({
      value,
      label: (options.find((option) => option.value === value)?.label as string) || value,
    })
  );
